import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {LocationType} from "../../../commons/types/location.type";
import {CustomersDialogService} from "../../../customers/services/customers-dialogs-service.service";
import {CustomerService} from "../../../customers/services/customers-service.service";
import {OmsService} from "../../../oms/services/oms-service.service";
import {AccountModel} from "../../../account/angular/models/account.model";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {FulfillmentTaskModel} from "../../models/fulfillment-task.model";

export class FulfillmentTaskLeanFormComponent implements IController {

  task: FulfillmentTaskModel; // FulfillmentTask
  accountId: any;
  accountBranchIds: any[];
  depotOptionIds: any;
  minDate: any;
  dateOptions: any;
  programType: any;
  notBefore: any;
  notAfter: any;
  isInvalidForm: boolean;
  isLocationRequired: boolean;
  isShowTimeWindow: boolean;
  onDateChange: Function;
  onChange: Function;


  public siteInfo: any;
  private configTimeZone: any;
  private customer: any;
  public selectedDateType: any;
  public minimumDate: any;
  public maximumDate: any;
  public selectedOperationHour: any;
  public locationAccountOptionsIds: string[];
  public isTaskHoursWithinOperationHoursRange: boolean = true;
  public locationTypes: typeof LocationType = LocationType;
  public dateTypes: any;


  constructor(private splitService, private moment, private $filter, private $log, private siteContextService: SiteContextService,
              private customersDialogService: CustomersDialogService, private customerService: CustomerService, private omsService: OmsService) {
    this.siteInfo = this.siteContextService.getSiteInfo();
    this.onlyValidPredicate = this.onlyValidPredicate.bind(this);
  }

  $onInit() {
    this.dateTypes = ['timeWindow', 'appointment'];
    this.selectedDateType = this.task.schedulingRequired ? 'appointment' : this.dateTypes[0];
    this.configTimeZone = this.splitService.getTimeZone();

    if (this.programType) {
      this._getTaskTimeSlotOptions();
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.accountId) {
      this.locationAccountOptionsIds = this.accountId ? [this.accountId] : undefined;
    }
    if (changes.programType && !changes.programType.isFirstChange()) {
      this._getTaskTimeSlotOptions();
    }
    if (changes.dateOptions && !changes.dateOptions.isFirstChange()) {
      this.minimumDate = new Date(_.min(this.dateOptions));
      this.maximumDate = new Date(_.max(this.dateOptions));
    }
    if (changes.notBefore && !changes.notBefore.isFirstChange() ||
      changes.notAfter && !changes.notAfter.isFirstChange()) {

      const currentNotBefore = _.get(changes, 'notBefore.currentValue'),
        previousNotBefore = _.get(changes, 'notBefore.previousValue'),
        currentNotAfter = _.get(changes, 'notAfter.currentValue'),
        previousNotAfter = _.get(changes, 'notAfter.previousValue');

      if (((changes.notBefore && !previousNotBefore) || currentNotBefore && !this.moment(currentNotBefore).isSame(this.moment(previousNotBefore), 'day')) ||
        ((changes.notAfter && !previousNotAfter) || currentNotAfter && !this.moment(currentNotAfter).isSame(this.moment(previousNotAfter), 'day'))) {
        this.isTaskHoursWithinOperationHoursRange = true;
        this._getTaskTimeSlotOptions();
      }

    }
  }

  onSelectDateType(selectedDateType) {
    this.task.schedulingRequired = undefined;
    this.task.obligateTimeWindow = undefined;
    if (selectedDateType === 'timeWindow') {
      this.task.notBefore = this.moment().startOf('day').valueOf();
      this.task.notAfter = this.moment().endOf('day').valueOf();
      this._getTaskTimeSlotOptions();
    } else {
      this.task.notBefore = undefined;
      this.task.notAfter = undefined
      this.task.schedulingRequired = true;
    }
    this.onChange({task: this.task});
  }

  onlyValidPredicate(date) {
    return !!_.filter(this.dateOptions, (day) => {
      return this._sameDay(new Date(day), date);
    }).length;
  }

  onLocationTypeChange(locationType) {
    this.customer = undefined;
    if (!this.task?.location) {
      this.task.location = {}
    }
    this.task.location.locationType = locationType;
    this.task.location.id = undefined;
    if (!this.task.contact) {
      this.task.contact = {}
    }
    this.task.contact = undefined;
    this.task.location.address = undefined;
    this.onChange({task: this.task});
  }

  onAccountSelect(account: AccountModel) {

    if (!this.task.contact) {
      this.task.contact = {};
    }
    this.task.location.id = _.get(account, 'id');
    this.task.contact.name = _.get(account, 'name');
    this.task.contact.businessName = _.get(account, 'name');
    this.task.contact.phoneNo = _.get(account, 'phoneNumber');
    this.task.contact.additionalPhoneNo = this.$filter('bringozPhone')(_.get(account, 'additionalPhoneNo'));
    this.task.location.address = _.get(account, 'address');
    if (account) {
      this._getTaskTimeSlotOptions();
    }
    this.onChange({task: this.task});
  }

  onDepotSelect(depot) {

    if (!this.task.contact) {
      this.task.contact = {};
    }

    this.task.location.id = _.get(depot, 'id');
    this.task.contact.name = _.get(depot, 'name');
    this.task.contact.businessName = _.get(depot, 'name');
    this.task.contact.phoneNo = _.get(depot, 'phoneNumber');
    this.task.contact.additionalPhoneNo = this.$filter('bringozPhone')(_.get(depot, 'additionalPhoneNo'));
    this.task.contact.customerId = undefined;
    this.task.location.address = _.get(depot, 'address');
    if (depot) {
      this._getTaskTimeSlotOptions();
    }
    this.onChange({task: this.task});
  }

  onCustomerSelect(customer) {

    if (!this.task.contact) {
      this.task.contact = {};
    }

    this.customer = customer;
    this.task.location.id = _.get(customer, 'id');
    this.task.contact.name = this._getCustomerName(customer);
    this.task.contact.businessName = _.get(customer, 'businessName');
    this.task.contact.phoneNo = _.get(customer, 'phone');
    this.task.contact.email = _.get(customer, 'email');
    this.task.contact.customerId = _.get(customer, 'id');

    this.task.location.address = _.find(_.get(customer, 'addresses', []), (a) => {
      return a.id === customer.defaultAddressId;
    })
    if (customer) {
      this._getTaskTimeSlotOptions();
    }
    this.onChange({task: this.task})
  }

  onPhoneChange(phone) {
    if (!this.task.contact) {
      this.task.contact = {};
    }
    this.task.contact.phoneNo = phone;
    this.onChange({task: this.task});
  }

  onAddressChange(address) {
    this.task.location.address = address;
    this.onChange({task: this.task});
  }

  onNotBeforeDateChange(date) {
    if (!this.moment(date).isSame(this.moment(this.task.notBefore), 'day')) {
      this.task.notBefore = this.moment(date).startOf('day').valueOf();
      this._onNotBeforeChange();
      this._getTaskTimeSlotOptions();
    }
  }

  onNotBeforeTimeChange(notBefore) {
    this.task.notBefore = notBefore;
    this.isTaskHoursWithinOperationHoursRange = this.omsService.isOrderTaskHoursWithinOperationHoursRange(this.selectedOperationHour.from, this.selectedOperationHour.to, this.task.notBefore, this.task.notAfter);
    this._onNotBeforeChange();
  }

  onNotAfterDateChange(date) {
    if (!this.moment(date).isSame(this.moment(this.task.notAfter), 'day')) {
      this.task.notAfter = this.moment(date).startOf('day').valueOf();
      this._onNotAfterChange();
      this._getTaskTimeSlotOptions()
    }
  }

  onNotAfterTimeChange(notAfter) {
    this.task.notAfter = notAfter;
    this.isTaskHoursWithinOperationHoursRange = this.omsService.isOrderTaskHoursWithinOperationHoursRange(this.selectedOperationHour.from, this.selectedOperationHour.to, this.task.notBefore, this.task.notAfter);
    this._onNotAfterChange();
  }

  private _onNotBeforeChange() {
    const minimumDateTimestamp = this.minimumDate ? this.moment(this.minimumDate).valueOf() : undefined;

    if (minimumDateTimestamp > this.task.notBefore) {
      this.task.notBefore = angular.copy(minimumDateTimestamp)
    }
    if (this.task.notBefore > this.task.notAfter) {
      this.task.notAfter = angular.copy(this.moment(this.task.notBefore).endOf('day').valueOf());
    }
    this.onDateChange({notBefore: this.task.notBefore});
  }

  private _onNotAfterChange() {
    const minimumDateTimestamp = this.minimumDate ? this.moment(this.minimumDate).valueOf() : undefined;

    if (minimumDateTimestamp > this.task.notAfter) {
      this.task.notAfter = angular.copy(minimumDateTimestamp)
    }
    if (this.task.notAfter < this.task.notBefore) {
      this.task.notBefore = angular.copy(this.task.notAfter);
    }
    this.onDateChange({notBefore: this.task.notBefore});
  }

  private _getCustomerName(customer) {
    return _.get(customer, 'firstName', '') + ' ' + _.get(customer, 'lastName', '');
  }

  private _sameDay(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();
  }

  private _getTaskTimeSlotOptions() {

    if (!_.get(this.task, 'location.address') || !this.isShowTimeWindow) {
      return;
    }

    if (!this.task.notBefore && !this.task.schedulingRequired) {
      this.task.notBefore = this.moment().startOf('day').valueOf();
    }

    if (!this.task.notAfter && !this.task.schedulingRequired) {
      this.task.notAfter = this.moment().endOf('day').valueOf();
    }


    if (!this.task.schedulingRequired) {
      this.omsService.getOrderTaskTimeSlots(
        this.task.location.locationType === LocationType.ACCOUNT ? this.task.location.id : this.accountId,
        this.task.location.locationType === LocationType.DEPOT ? this.task.location.id : undefined,
        'Delivery', this.task.notBefore, this.task.notAfter, this.programType, this.configTimeZone)
        .then((timeSlotOptions: any) => {
          if (timeSlotOptions.length > 0) {
            this.selectedOperationHour = angular.copy(timeSlotOptions[0]);
            this.task.notBefore = this.selectedOperationHour.from;
            this.task.notAfter = this.selectedOperationHour.to;
            this._onNotBeforeChange();
            this._onNotAfterChange();
          }
        }).catch(() => {

      })
    }
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentTaskLeanForm', {
    require: {
      form: '^form'
    },
    bindings: {
      task: '<',
      accountId: '<?',
      accountBranchIds: '<?',
      depotOptionIds: '<?',
      dateOptions: '<',
      programType: '<',
      minDate: '<?',
      notBefore: '<',
      notAfter: '<',
      isMarkerEnabled: '<?',
      isInvalidForm: '<',
      isLocationRequired: '<?',
      isShowTimeWindow: '<?',
      onDateChange: '&',
      onChange: '&',
    },
    template: require('./fulfillment-task-lean-form.html').default,
    controller: FulfillmentTaskLeanFormComponent
  });
